// extracted by mini-css-extract-plugin
export default {"content":"aGQ8F","sportContainer":"lGix8"};